import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIvecoComponent } from './simple-icons-iveco.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIvecoComponent ],
    exports:      [ SimpleIconsIvecoComponent ],
    bootstrap:    []
})
export class SimpleIconsIvecoModule {}
